/* ============
 * State of requirements module
 * ============
 *
 * The initial state of the requirements module.
 */

export default {
  requirements: null
}



// WEBPACK FOOTER //
// ./src/store/modules/requirements/state.js